import { render, staticRenderFns } from "./rceive.vue?vue&type=template&id=fd5a3e86&"
import script from "./rceive.vue?vue&type=script&lang=js&"
export * from "./rceive.vue?vue&type=script&lang=js&"
import style0 from "./rceive.vue?vue&type=style&index=0&id=fd5a3e86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports